import React from 'react';
import cn from 'classname';
import './index.less';

import { Link } from 'react-router';

import withCheckPermission from '../../../../../../../shared/check-permission-hoc';

import { enum as permissions } from '../../../../../../../../../../../enums/admin-permissions';

function PayoutAffiliate({ check, affiliate }) {
	return check(permissions.affiliatesList) ? (
		<div>
			<Link
				className='payout-table--body--affiliate--link id'
				to={`/affiliates/profile/${affiliate.id}`}
			>
				{affiliate.id}
			</Link>
			<Link
				className={'payout-table--body--affiliate--link'}
				to={`/affiliates/profile/${affiliate.id}`}
			>
				{affiliate.email}
				<span className={cn(affiliate.is_suspicious && 'suspicious')}></span>
				<span className={cn(affiliate.is_possible_fraud && 'is_fraud')}></span>
			</Link>
		</div>
	) : (
		<div>
			<span
				className='payout-table--body--affiliate--span id'
			>
				{affiliate.id}
			</span>
			<span
				className={cn('payout-table--body--affiliate--span', affiliate.is_suspicious && 'suspicious')}
			>
				{affiliate.email}
			</span>
		</div>
	);
}

export default withCheckPermission(PayoutAffiliate);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-affiliate/index.js